import React from 'react';
import {
  ReserveProviderProps,
  ReserveState,
  ReserveModalDisclosureOptions
} from './types';
import { ReserveContext } from './context';
import { useDisclosure } from '@gettactic/helpers/src';
import { ReserveModal } from '@/components/reserve/Reserve/ReserveModal';
import { useResource } from '@gettactic/hooks';

export const ReserveProvider: React.FC<
  React.PropsWithChildren<ReserveProviderProps>
> = ({ children, withModal = true }) => {
  const reserveModalDisclosure = useDisclosure<ReserveModalDisclosureOptions>();

  const { resource } = useResource(reserveModalDisclosure.data?.resource?.id, {
    enabled: reserveModalDisclosure.isOpen
  });

  const value: ReserveState = {
    openReserveModal: (
      options?: ReserveModalDisclosureOptions,
      forcePassThrough = false
    ) => {
      if (forcePassThrough) {
        // Pass to main provider
        return;
      }
      reserveModalDisclosure.open(options);
    },
    closeReserveModal: () => reserveModalDisclosure.close(undefined),
    reserveData: reserveModalDisclosure.data,
    isReserveOpen: reserveModalDisclosure.isOpen,
    resource
  };

  return (
    <ReserveContext.Provider value={value}>
      {children}
      {withModal && (
        <ReserveModal
          reserveModal={reserveModalDisclosure.isOpen}
          resourceType={reserveModalDisclosure.data?.resourceType || 'desk'}
          start={reserveModalDisclosure.data?.start || new Date()}
          onClose={reserveModalDisclosure.close}
          resource={resource}
          duration={reserveModalDisclosure.data?.duration}
          time={reserveModalDisclosure.data?.time}
          floorId={reserveModalDisclosure.data?.floorId}
          office={reserveModalDisclosure.data?.office}
          isEmbedded={reserveModalDisclosure.data?.isEmbedded || false}
        />
      )}
    </ReserveContext.Provider>
  );
};
